module.exports = __webpack_public_path__ + "fonts/gotham_book.7f34eb0.otf";